import { render, staticRenderFns } from "./ResourceGrid.vue?vue&type=template&id=31dcda0f&"
import script from "./ResourceGrid.vue?vue&type=script&lang=js&"
export * from "./ResourceGrid.vue?vue&type=script&lang=js&"
import style0 from "./ResourceGrid.vue?vue&type=style&index=0&id=31dcda0f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports